import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, switchMap, throwError } from 'rxjs';
import { AuthService } from '../auth/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const auth = inject(AuthService);
  const isRefreshCall = req.url.includes('/auth/refresh');
  const isGcsCall     = req.url.includes('storage.googleapis.com');

  // Only attach the access token to calls going to our own backend
  if (!isRefreshCall && !isGcsCall) {
    const token = auth.token;
    if (token) {
      req = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
    }
  }

  return next(req).pipe(
    catchError((err: HttpErrorResponse) => {
      // Only attempt refresh on 401s that aren't from the refresh call itself
      if (err.status !== 401 || isRefreshCall) {
        return throwError(() => err);
      }

      return auth.refreshAccessToken().pipe(
        switchMap((newToken) =>
          next(req.clone({ setHeaders: { Authorization: `Bearer ${newToken}` } })),
        ),
        catchError((refreshErr) => {
          auth.logout();
          return throwError(() => refreshErr);
        }),
      );
    }),
  );
};
